function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgChat = function SvgChat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("path", {
    style: {
      fill: "#FFCD38"
    },
    d: "M13.138,265.032c10.878-5.119,28.404-15.356,37.742-31.398C19.352,210.015,0,178.053,0,142.868 C0,70.145,82.669,11.191,184.646,11.191s184.646,58.954,184.646,131.678s-82.669,131.678-184.646,131.678 c-27.903,0-54.353-4.423-78.067-12.324c-11.262,8.743-43.426,27.891-93.052,10.586C9.979,271.571,9.739,266.632,13.138,265.032z"
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#3A484A"
    },
    d: "M239.487,152.909c-4.267,0-7.726-3.459-7.726-7.726v-9.926c0-4.267,3.459-7.726,7.726-7.726 s7.726,3.459,7.726,7.726v9.926C247.214,149.449,243.754,152.909,239.487,152.909z"
  }), React.createElement("path", {
    style: {
      fill: "#3A484A"
    },
    d: "M129.804,152.909c-4.267,0-7.726-3.459-7.726-7.726v-9.926c0-4.267,3.459-7.726,7.726-7.726 s7.726,3.459,7.726,7.726v9.926C137.53,149.449,134.071,152.909,129.804,152.909z"
  }), React.createElement("path", {
    style: {
      fill: "#3A484A"
    },
    d: "M184.646,158.207c-7.505,0-14.559-3.145-19.353-8.63c-2.808-3.213-2.481-8.094,0.732-10.902 c3.213-2.808,8.094-2.481,10.902,0.732c1.859,2.127,4.673,3.347,7.719,3.347s5.86-1.22,7.718-3.347 c2.809-3.213,7.689-3.54,10.902-0.732c3.213,2.808,3.541,7.689,0.732,10.902C199.204,155.061,192.15,158.207,184.646,158.207z"
  })), React.createElement("path", {
    style: {
      fill: "#E7B835"
    },
    d: "M348.687,120.351c0-19.235-5.073-37.623-14.302-54.53c21.956,21.664,34.906,48.275,34.906,77.048 c0,72.724-82.669,131.677-184.646,131.677c-15.319,0-30.195-1.34-44.424-3.85C255.57,269.782,348.687,202.827,348.687,120.351z"
  }), React.createElement("path", {
    style: {
      fill: "#49C3E0"
    },
    d: "M498.862,486.033c-10.878-5.119-28.404-15.356-37.742-31.398 c31.528-23.621,50.88-55.582,50.88-90.767c0-72.724-82.669-131.678-184.646-131.678s-184.646,58.954-184.646,131.678 s82.669,131.678,184.646,131.678c27.903,0,54.353-4.423,78.067-12.324c11.262,8.743,43.426,27.891,93.052,10.586 C502.021,492.571,502.261,487.632,498.862,486.033z"
  }), React.createElement("path", {
    style: {
      fill: "#00A5C6"
    },
    d: "M163.314,341.35c0-19.234,5.073-37.623,14.302-54.53c-21.956,21.664-34.906,48.275-34.906,77.048 c0,72.724,82.669,131.677,184.646,131.677c15.319,0,30.195-1.34,44.424-3.85C256.43,490.782,163.314,423.827,163.314,341.35z"
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#3A484A"
    },
    d: "M272.513,373.908c-4.267,0-7.726-3.459-7.726-7.726v-9.926c0-4.267,3.459-7.726,7.726-7.726 s7.726,3.459,7.726,7.726v9.926C280.239,370.449,276.78,373.908,272.513,373.908z"
  }), React.createElement("path", {
    style: {
      fill: "#3A484A"
    },
    d: "M382.196,373.908c-4.267,0-7.726-3.459-7.726-7.726v-9.926c0-4.267,3.459-7.726,7.726-7.726 s7.726,3.459,7.726,7.726v9.926C389.922,370.449,386.463,373.908,382.196,373.908z"
  }), React.createElement("path", {
    style: {
      fill: "#3A484A"
    },
    d: "M327.354,379.206c-7.505,0-14.559-3.145-19.353-8.63c-2.808-3.213-2.481-8.094,0.732-10.902 c3.213-2.808,8.094-2.481,10.902,0.732c1.859,2.127,4.673,3.347,7.718,3.347s5.86-1.22,7.719-3.347 c2.808-3.213,7.688-3.541,10.902-0.732c3.213,2.808,3.541,7.689,0.732,10.902C341.913,376.061,334.859,379.206,327.354,379.206z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat.ee0239d9.svg";
export { ForwardRef as ReactComponent };